module.exports = __webpack_public_path__ + "static/media/VectorLocation.92907c9f.svg";